<template>
  <nav
    class="navbar navbar-expand-lg navbar-light bg-light"
    style="height: 50px"
  >
    <div class="container-fluid">
      <button class="btn rounded-0 btn-sm" @click="redirect">
        <img
          src="@/assets/icon-back.png"
          class="img-fluid thai-qr-image"
          width="13"
          alt="Icon Back"
        />
      </button>
      <div class="mx-auto">
        <div class="title-header">ยืนยันการสั่งซื้อ</div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'OrderSummaryHeader',
  methods: {
    redirect() {
      // window.history.back();
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.title-header {
  font-size: 24px;
}

@media screen and (max-width: 480px) {
  .title-header {
    font-size: 16px;
  }
}
</style>
